import { LanguageModelV1FinishReason } from '@ai-sdk/provider';

export function mapDifyFinishReason(
    finishReason: string | null | undefined,
): LanguageModelV1FinishReason {
    switch (finishReason) {
        case 'stop':
            return 'stop';
        case 'length':
        case 'model_length':
            return 'length';
        case 'tool_calls':
            return 'tool-calls';
        default:
            return 'unknown';
    }
}
